import React from 'react';


export default function Example() {
    return (
        <div style={{ padding: '30px' }}>
            <ul>
                <li>
                    <a href='https://aocdweb.com/BioTools/cocomaps2/mols?f=Li4vZGF0YS8yMDI1MDgwNS9uT0didE1TUHNILw==&p=MlpBNA==&c1=QQ==&c2=Qg==&pn=&mol1=&mol2='>
                    Protein-Protein: 2ZA4 A vs B </a>
                </li>
                <li>
                    <a href='https://aocdweb.com/BioTools/cocomaps2/mols?f=Li4vZGF0YS8yMDI1MDgwNS9GVDNScndNM0I5Lw==&p=M0xRWA==&c1=QQ==&c2=Qg==&pn=&mol1=&mol2='>
                    Protein-RNA: 3LQX A vs B </a>
                </li>
                <li>
                    <a href='https://aocdweb.com/BioTools/cocomaps2/mols?f=Li4vZGF0YS8yMDI1MDgwNS9XcnNWTXJPZG00Lw==&p=M1FNRA==&c1=QQ==&c2=Qg==&pn=&mol1=&mol2='>
                    Protein-DNA: 3QMD A vs B </a>
                </li>
                <li>
                    <a href='https://aocdweb.com/BioTools/cocomaps2/mols?f=Li4vZGF0YS8yMDI1MDgwNS9VV08xbVRxaWVWLw==&p=M1FNRA==&c1=QQ==&c2=Qw==&pn=&mol1=&mol2='>
                    Protein-DNA: 3QMD A vs C  </a>
                </li>
            </ul>
        </div>
    )
}